import type { FC } from "react";

import type { TFormProps } from "@/ui/components/form/Form/Form.config";

export const Form: FC<TFormProps> = (
  {
    children,
    "data-component": component = "Form",
    ...props
  },
) => (
  <form
    {...props}
    data-component={component}
  >
    { children }
  </form>
);

Form.displayName = "Form";
